export interface SEOProps {
	siteName: string
	siteDescription?: string
	pageTitle?: string

	meta?: {
		title?: string
		description?: string
	}

	openGraph?: {
		cardImageUrl?: string
	}

	twitter?: {
		username?: string
		cardImageUrl?: string
	}
}

export const SEO = ({
	siteName,
	siteDescription,
	pageTitle,
	meta,
	openGraph,
	twitter,
}: SEOProps) => {
	const description = meta?.description || siteDescription
	const title =
		meta?.title || pageTitle ? `${pageTitle} | ${siteName}` : siteName

	return (
		<>
			<title>{title}</title>
			<meta property="og:title" content={title} />
			<meta name="twitter:title" content={title} />

			{description && (
				<>
					<meta name="description" content={description} />
					<meta property="og:description" content={description} />
					<meta name="twitter:description" content={description} />
				</>
			)}

			{/* Open Graph */}
			<meta property="og:type" content="website" />
			<meta property="og:site_name" content={siteName} />
			{openGraph?.cardImageUrl && (
				<meta
					name="image"
					property="og:image"
					content={openGraph.cardImageUrl}
				/>
			)}

			{/* Twitter */}
			<meta name="twitter:card" content="summary_large_image" />
			{twitter?.cardImageUrl && (
				<meta name="twitter:image" content={twitter.cardImageUrl} />
			)}
			{twitter?.username && (
				<meta name="twitter:site" content={twitter.username} />
			)}
		</>
	)
}
